import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    debug: false,

    menuClass: '',
    guestName: '',
    guestType: '',
    candidate: {
      type: '',
      position: ''
    },
    client: {
      contactType: '',
      businessState: '',
      interests: ''
    }
  },
  mutations: {
    increment(state) {
      state.count++
    },
    setMenuClass(state, className) {
      state.menuClass = className;
    },
    setGuestName(state, name) {
      state.guestName = name;
    },
    /**
     * Ste the gest type (candidate|client)
     * @param state
     * @param type
     */
    setGuestType(state, type) {
      state.guestType = type
    },
    setCandidateType(state, val) {
      state.candidate.type = val;
    },
    setCandidatePosition(state, val) {
      state.candidate.position = val;
    },
    setBusinessStage(state, val) {
      state.client.businessState = val;
    },
    setBusinessInterests(state, val) {
      state.client.interests = val;
    }
  },
  getters: {
    guestFirstName: state => {
      return state.guestName.split(' ')[0];
    },
    getMenuClass: state => {
      return 'menu MainMenu.vue ' + state.menuClass;
    }
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js